module.exports = __webpack_public_path__ + "img/mp3player.11c5e269.png";